import { useQuery } from '@tanstack/react-query';
import { apiUrlGenerator } from 'infrastructure/hooks/use-api';
import dataService from 'services/dataService';

import type { IProviderDashboardRpmDetails } from 'components/organisms/provider-dashboard';

export interface IGetProviderDashboardRpmDetailsFilters {
  startDate: string;
  endDate: string;
  clinicGuid?: string[];
  parentClinicGuid?: string[];
  providerGuid?: string;
}

const url = 'core-2/provider-dashboard/rpm-details';

export const getProviderDashboardRpmDetailsQueryKey = (
  filters: IGetProviderDashboardRpmDetailsFilters,
) => [url, filters] as const;

const queryFn = async (filters: IGetProviderDashboardRpmDetailsFilters) => {
  const { data, error } =
    await dataService.getList<IProviderDashboardRpmDetails>(
      apiUrlGenerator(url, filters),
    );

  if (error) {
    return Promise.reject(error);
  }

  return data;
};

export const useGetProviderDashboardRpmDetails = (
  filters: IGetProviderDashboardRpmDetailsFilters,
  enabled = true,
) => {
  const queryKey = getProviderDashboardRpmDetailsQueryKey(filters);

  const { data, isLoading, isFetching } = useQuery<
    IProviderDashboardRpmDetails | undefined,
    string | undefined
  >({
    queryKey,
    queryFn: async () => queryFn(filters),
    keepPreviousData: true,
    enabled,
  });

  return {
    rpmDetails: data,
    isLoading,
    isFetching,
  };
};
